<template>
  <div
    style="padding: 20px; height: 100%; flex-direction: column"
    class="between"
  >
    <div style="width: 100%;">
      <div
        style="
          font-weight: 500;
          font-size: 16px;
          color: #1d2129;
          line-height: 20px;
          padding-bottom: 18px;
          border-bottom: 1px solid #f3f5f8;
        "
      >
        应用日志
      </div>
      <div style="padding: 20px 0 6px">
        <el-form
          ref="form"
          :model="form"
          label-width="70px"
          label-position="left"
        >
          <el-row :gutter="10">
            <el-col :span="5">
              <el-form-item label="操作人">
                <el-input v-model="form.createName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="操作类型">
                <el-select v-model="form.type" clearable>
                  <!-- <el-option label="全部" :value="0"></el-option> -->
                  <el-option label="新增" :value="1"></el-option>
                  <el-option label="编辑" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="操作表单">
                <el-input v-model="form.formName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="操作时间">
                <el-date-picker
                  v-model="form.created"
                  type="daterange"
                  range-separator="——"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div
                style="
                  width: 70px;
                  height: 32px;
                  background: #107fff;
                  border-radius: 4px;
                  font-size: 16px;
                  color: #ffffff;
                  line-height: 20px;
                  letter-spacing: 2px;
                  float: right;
                  cursor: pointer;
                  user-select: none;
                "
                class="center"
                @click="getList"
              >
                查询
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div style="flex: 1; height: 100%; width: 100%">
      <el-table
        :data="data"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        height="100%"
      >
        <el-table-column prop="createName" label="操作人"> </el-table-column>
        <el-table-column prop="type" label="操作类型"> </el-table-column>
        <el-table-column prop="created" label="操作时间"> </el-table-column>
        <el-table-column prop="moduleName" label="所属应用"> </el-table-column>
        <el-table-column prop="formName" label="操作表单"> </el-table-column>
        <el-table-column prop="detail" label="操作内容"> </el-table-column>
        <el-table-column prop="ip" label="IP"> </el-table-column>
      </el-table>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin-top: 9px;
      "
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        :current-page="form.pageNumber"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { dataLogModulePage } from "@/api/module";
import { headerCellStyle } from "@/utils/CustomUtil.js";
export default {
  data() {
    return {
      form: {
        pageSize: 10,
        pageNumber: 1,
      },
      data: [],
      loading: false,
      total: 0,
    };
  },
  methods: {
    headerCellStyle,
    async getList() {
      const res = await dataLogModulePage(this.form);
      this.data = res.data.records;
      this.total = res.data.total;
    },
    handleSizeChange(val) {
      if (!this.total) return;
      this.form.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      if (!this.total) return;
      this.form.pageNumber = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item__content {
  line-height: 32px;
}
/deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-form-item__label {
  line-height: 32px;
}
/deep/.el-date-editor .el-range__icon {
  line-height: 24px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 22px;
}
/deep/.el-input__icon {
  line-height: 32px;
}
/deep/.el-date-editor .el-range__close-icon {
  line-height: 24px;
}

/deep/.el-date-editor .el-range-separator {
  color: #bfbfbf;
}
</style>